import React from "react";
import Header from "../../../components/Header/Header";
import images from "../../../images";
import { useNavigate, useParams } from "react-router-dom";
import { useGetQuestTakeResultQuery } from "../../../services/apiSlice";
import LoadingCommon from "../../../components/common/LoadingStatus/LoadingCommon";
import { useTranslation } from "react-i18next";

const TaskResults = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { id } = useParams();

  const { data: questTakeResultData, isLoading: isLoadingObjectiveData } =
    useGetQuestTakeResultQuery(
      {
        quest_business_id: id,
      },
      { skip: !id }
    );

  return (
    <main className="overflow-hidden mx-auto w-full bg-neutral-50 max-w-[480px]">
      <LoadingCommon statusLoading={isLoadingObjectiveData} />
      <div className="w-full min-h-[920px]">
        <section className="flex flex-col justify-center  pb-4 w-full bg-[#3F54DF] rounded-none">
          <Header
            title="Quest Result"
            backIcon={images.BackIcon}
            onBackClick={() => navigate(-1)}
          />
        </section>
        {questTakeResultData?.data ? (
          <section className="flex flex-col flex-1 justify-between items-center p-3.5 w-full">
            <article className="flex flex-col justify-center p-3 max-w-full bg-white rounded-xl text-zinc-800 w-[396px]">
              <div className="w-full">
                <header className="flex gap-3 items-center w-full text-lg font-semibold whitespace-nowrap">
                  <h2 className="gap-1.5 self-stretch my-auto">
                    {t("base.summary")}
                  </h2>
                </header>
                <p className="flex-1 shrink gap-2.5 self-stretch px-2 py-2.5 mt-4 w-full text-sm font-medium tracking-wide bg-yellow-50 rounded-xl basis-0">
                  {questTakeResultData?.data?.quest_result.summary}
                </p>
              </div>
            </article>
            <img
              src={images.QuestResultImage}
              alt="Task illustration"
              className="object-contain mt-36 max-w-full aspect-[1.88] w-[301px]"
            />
            <button
              onClick={() => navigate(`/quest/result/take/${id}`)}
              className="flex gap-2.5 mt-8 justify-center items-center self-stretch px-5 py-4 w-full text-base font-semibold text-white bg-[#3F54DF] rounded-xl min-h-[54px]"
            >
              <span className="self-stretch my-auto">
                {t("quest.questResult.startSlideShow")}
              </span>
              <img
                src={images.SlideIcon}
                alt="Start icon"
                className="object-contain shrink-0 self-stretch my-auto w-6 aspect-square"
              />
            </button>
          </section>
        ) : (
          <section className="flex flex-col flex-1 justify-between items-center p-3.5 w-full">
            <div className="flex justify-center items-center h-full  mt-10">
              <p className="text-zinc-400">{t("base.noDataAvailable")}</p>
            </div>
          </section>
        )}
      </div>
    </main>
  );
};

export default TaskResults;
